import type { Reactive } from '@rehaje/reactive'

const skipCreateNodeMap = new WeakSet()
const skipCreateModelMap = new WeakSet()

export function isSkipCreateTypedModel<T>(value?: T): boolean {
  if (typeof value === 'object' && value !== null)
    return skipCreateModelMap.has(value)
  return false
}
export function isSkipCreateTypedNode<T>(value?: T): boolean {
  if (typeof value === 'object' && value !== null)
    return skipCreateNodeMap.has(value)
  return false
}

export function skipCreateTypedModel<T>(value?: T): T

export function skipCreateTypedModel(value?: Reactive) {
  if (typeof value === 'object' && value !== null) skipCreateModelMap.add(value)
  return value
}
export function skipCreateTypedNode<T>(value?: T): T

export function skipCreateTypedNode(value?: Reactive) {
  if (typeof value === 'object' && value !== null) skipCreateNodeMap.add(value)
  return value
}
